module.exports = __webpack_public_path__ + "img/logo-dark.a233ee8d.png";